
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30730',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30730",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55246",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8289",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11744",
  "I18n": "static-7.1665",
  "quartz": "static-1.7395",
  "quartz-config": "static-1.1173",
  "quartz-core": "static-1.6614",
  "react-dlb": "static-1.86",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.77",
  "reselect": "static-3.9",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.876",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55233",
  "feedback-utils": "static-1.55237",
  "forms-embed-utils-lib": "static-1.4725",
  "forms-utils-lib": "static-1.13039",
  "foundations-assets": "static-1.5144",
  "foundations-components": "static-1.8418",
  "foundations-theming": "static-1.4727",
  "hub-http": "static-1.6473",
  "hubspot-url-utils": "static-1.4297",
  "HubStyle": "static-2.12051",
  "icons": "static-2.675",
  "immutable": "static-2.83",
  "quick-fetch": "static-1.4104",
  "raven": "static-3.5925",
  "react": "static-7.191",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.16972",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5528",
  "react-virtualized": "static-2.104",
  "redux": "static-4.76",
  "StyleGuideUI": "static-3.497",
  "tinymce-plugins": "static-1.58143",
  "transmute": "static-2.85",
  "ui-images": "static-2.1233",
  "UIComponents": "static-3.8690",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3591",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3672",
  "quartz-webpack": "static-1.3619",
  "foundations-theming-specialty": "static-1.2443",
  "property-description-translator": "static-1.4100",
  "HeadJS": "static-2.791",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3400",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.228",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4577",
  "jasmine-runner": "static-1.6711",
  "opentelemetry-fe-types": "static-1.30",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.871",
  "hubspotter-http": "static-1.4836",
  "mobile-manifest-mixins": "static-1.569",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.405",
  "quartz-auth": "static-1.1070",
  "quartz-head": "static-1.1060",
  "quartz-i18n": "static-1.1070",
  "quartz-routing": "static-1.825",
  "quartz-test": "static-1.1070",
  "quartz-tracking": "static-1.774",
  "trellis-components": "static-1.2537",
  "ui-fonts": "static-1.1006",
  "usage-tracker-container": "static-1.7607",
  "usage-tracker-core": "static-1.7467",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.163",
  "conversations-skeleton-state": "static-1.7509",
  "reference-resolvers": "static-1.8440",
  "sanitize-text": "static-1.8412",
  "PatternValidationJS": "static-1.3158",
  "ReduxMessenger": "static-2.10628",
  "sanitize": "static-1.4736",
  "outpost": "static-1.4420",
  "rpc-client-utils": "static-1.4923",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4687",
  "floating-ui": "static-1.62",
  "hs-story-utils": "static-1.9687",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.64",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2518",
  "bend-plugin-foundations-theming": "static-1.3210",
  "foundations-theming-base": "static-1.3712",
  "stylex": "static-1.38",
  "hs-locale-management": "static-1.265",
  "csstype": "static-1.50",
  "web-vitals": "static-1.11",
  "ai-components-ui-library": "static-1.9627",
  "atom": "static-1.5346",
  "codemirror": "static-5.99",
  "content-assistance-lib": "static-1.8148",
  "ContentUtils": "static-1.69063",
  "data-token-picker": "static-1.16834",
  "file-manager-components": "static-1.24395",
  "FileManagerCore": "static-1.39894",
  "FileManagerLib": "static-1.40035",
  "frontend-preferences-client": "static-1.8187",
  "hub-http-contrib": "static-1.3298",
  "interframe": "static-3.5016",
  "layout-dnd-components": "static-1.12908",
  "layout-dnd-utils": "static-1.11883",
  "property-translator": "static-1.5657",
  "react-codemirror": "static-1.10899",
  "react-colorpicker": "static-2.10468",
  "reference-resolvers-lite": "static-1.8361",
  "rich-text-lib": "static-1.20252",
  "tinymce-data": "static-1.41114",
  "tinymce-themes": "static-1.56999",
  "ui-addon-emoji-picker": "static-1.10146",
  "ui-addon-sales-email": "static-1.5476",
  "ui-brand-identity-lib": "static-1.16282",
  "bender-build-tools": "static-1.3397",
  "opentelemetry-web": "static-1.11",
  "hub-http-shared-msw-handlers": "static-1.10550",
  "hubspotter-http-shared-msw-handlers": "static-1.10548",
  "usage-tracker-session-replay": "static-1.5303",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1227",
  "tanstack-virtual": "static-1.36",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.333",
  "chirp-fetch": "static-1.2154",
  "chatspot-core": "static-1.22712",
  "copilot-toolkit": "static-1.11774",
  "customer-data-objects-ui-components": "static-1.13290",
  "data-fetching-client": "static-1.9918",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5016",
  "ui-addon-video-player": "static-1.8964",
  "ui-coaching-tips": "static-1.29240",
  "usage-tracker": "static-1.7617",
  "cms-field-types": "static-1.5075",
  "content-icons-ui": "static-1.2324",
  "integrations-lib": "static-1.16955",
  "customer-data-objects": "static-1.7948",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1606",
  "apollo-link-hub-http": "static-2.4916",
  "apollo-stack-hubspot": "static-3.90",
  "graphql": "static-1.86",
  "immer": "static-1.94",
  "immerable": "static-1.4412",
  "ui-addon-iframeable": "static-1.9335",
  "video-components-external": "static-1.12086",
  "video-data-lib": "static-1.35744",
  "breeze-artifacts-sdk": "static-1.225",
  "audio-components": "static-1.6288",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29753",
  "FileManagerImages": "static-1.37546",
  "foundations-components-legacy": "static-1.1443",
  "html-to-image": "static-1.58",
  "redux-toolkit": "static-1.75",
  "salesImages": "static-1.532",
  "ui-universal-auth": "static-1.9320",
  "urlinator": "static-1.4793",
  "video-components": "static-1.14088",
  "video-embed": "static-1.36578",
  "ts-schema": "static-1.4266",
  "ContentData": "static-1.69138",
  "layout-data-lib": "static-1.10208",
  "react-dnd-compat": "static-1.4876",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1801",
  "external-options-client-types": "static-1.4313",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7153",
  "hs-promise-utils": "static-1.5855",
  "inbound-db-properties-service-client": "static-1.4030",
  "NamespacedHubStyle": "static-2.9235",
  "growth-onboarding-confetti": "static-1.3323",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11404",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5727",
  "magpie-types": "static-1.5187",
  "simple-logging-lib": "static-1.3311",
  "avatar-components": "static-1.2755",
  "customer-data-ui-utilities": "static-1.10088",
  "growth-onboarding-feedback-components": "static-1.6845",
  "flux-actions": "static-1.362",
  "hubspot-apollo-client": "static-1.5139",
  "integrations-error-boundary-lib": "static-1.14370",
  "integrations-tracking-lib": "static-1.5868",
  "laboratory-lib": "static-3.7413",
  "native-integrations-shared-strings": "static-1.8038",
  "redux-observable": "static-1.72",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10525",
  "unified-auth": "static-1.834",
  "breeze-engine-chat-components": "static-1.584",
  "breeze-engine-core": "static-1.884",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "navigation-messaging": "static-1.8065",
  "content-media-composition-data-lib": "static-1.13148",
  "content-media-compositions": "static-2.17155",
  "idb-keyval": "static-1.48",
  "media-bridge-lib": "static-1.19352",
  "unified-auth-core-lib": "static-1.1116",
  "social-insights-client-types": "static-1.22685",
  "advanced-menus-core": "static-1.15525",
  "advanced-menus-lib": "static-1.12404",
  "ExportDialog": "static-6.10639",
  "ui-memberships-settings-lib": "static-1.34767",
  "conditional-properties-service-client": "static-1.3986",
  "crm-pipelines-api-client-types": "static-1.4320",
  "fdsr-migration-layer": "static-1.272",
  "framework-builder-read-service-client": "static-1.4194",
  "framework-data-schema-quick-fetch": "static-1.7058",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3881",
  "persist-promise": "static-1.3958",
  "foundations-components-test-utils": "static-1.5901",
  "reactive-lib": "static-1.982",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.598",
  "universal-page-editor-lib": "static-1.3268",
  "adobe-sign-auth-lib": "static-1.380",
  "ads-unified-auth-lib": "static-1.1133",
  "google-sheets-integration-lib": "static-1.956",
  "microsoft-drive-auth-lib": "static-1.53",
  "surveymonkey-integration-lib": "static-1.400",
  "slack-ui-library": "static-1.10659",
  "js-cookie": "static-1.18",
  "fsm": "static-1.4001",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15524",
  "simple-menus-lib": "static-1.17041",
  "crm-record-cards-service-types": "static-1.3759",
  "location-customization-utils-lib": "static-1.10018",
  "react-flip-move": "static-1.75"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30730",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55246",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8289",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11744",
  "I18n": "/I18n/static-7.1665",
  "quartz": "/quartz/static-1.7395",
  "quartz-config": "/quartz-config/static-1.1173",
  "quartz-core": "/quartz-core/static-1.6614",
  "react-dlb": "/react-dlb/static-1.86",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.77",
  "reselect": "/reselect/static-3.9",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.876",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55233",
  "feedback-utils": "/feedback-utils/static-1.55237",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4725",
  "forms-utils-lib": "/forms-utils-lib/static-1.13039",
  "foundations-assets": "/foundations-assets/static-1.5144",
  "foundations-components": "/foundations-components/static-1.8418",
  "foundations-theming": "/foundations-theming/static-1.4727",
  "hub-http": "/hub-http/static-1.6473",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyle": "/HubStyle/static-2.12051",
  "icons": "/icons/static-2.675",
  "immutable": "/immutable/static-2.83",
  "quick-fetch": "/quick-fetch/static-1.4104",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.191",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.16972",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5528",
  "react-virtualized": "/react-virtualized/static-2.104",
  "redux": "/redux/static-4.76",
  "StyleGuideUI": "/StyleGuideUI/static-3.497",
  "tinymce-plugins": "/tinymce-plugins/static-1.58143",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1233",
  "UIComponents": "/UIComponents/static-3.8690",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3591",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3672",
  "quartz-webpack": "/quartz-webpack/static-1.3619",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2443",
  "property-description-translator": "/property-description-translator/static-1.4100",
  "HeadJS": "/HeadJS/static-2.791",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3400",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.228",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4577",
  "jasmine-runner": "/jasmine-runner/static-1.6711",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.30",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.871",
  "hubspotter-http": "/hubspotter-http/static-1.4836",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.569",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.405",
  "quartz-auth": "/quartz-auth/static-1.1070",
  "quartz-head": "/quartz-head/static-1.1060",
  "quartz-i18n": "/quartz-i18n/static-1.1070",
  "quartz-routing": "/quartz-routing/static-1.825",
  "quartz-test": "/quartz-test/static-1.1070",
  "quartz-tracking": "/quartz-tracking/static-1.774",
  "trellis-components": "/trellis-components/static-1.2537",
  "ui-fonts": "/ui-fonts/static-1.1006",
  "usage-tracker-container": "/usage-tracker-container/static-1.7607",
  "usage-tracker-core": "/usage-tracker-core/static-1.7467",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.163",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7509",
  "reference-resolvers": "/reference-resolvers/static-1.8440",
  "sanitize-text": "/sanitize-text/static-1.8412",
  "PatternValidationJS": "/PatternValidationJS/static-1.3158",
  "ReduxMessenger": "/ReduxMessenger/static-2.10628",
  "sanitize": "/sanitize/static-1.4736",
  "outpost": "/outpost/static-1.4420",
  "rpc-client-utils": "/rpc-client-utils/static-1.4923",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4687",
  "floating-ui": "/floating-ui/static-1.62",
  "hs-story-utils": "/hs-story-utils/static-1.9687",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2518",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3210",
  "foundations-theming-base": "/foundations-theming-base/static-1.3712",
  "stylex": "/stylex/static-1.38",
  "hs-locale-management": "/hs-locale-management/static-1.265",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.11",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9627",
  "atom": "/atom/static-1.5346",
  "codemirror": "/codemirror/static-5.99",
  "content-assistance-lib": "/content-assistance-lib/static-1.8148",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "data-token-picker": "/data-token-picker/static-1.16834",
  "file-manager-components": "/file-manager-components/static-1.24395",
  "FileManagerCore": "/FileManagerCore/static-1.39894",
  "FileManagerLib": "/FileManagerLib/static-1.40035",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8187",
  "hub-http-contrib": "/hub-http-contrib/static-1.3298",
  "interframe": "/interframe/static-3.5016",
  "layout-dnd-components": "/layout-dnd-components/static-1.12908",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11883",
  "property-translator": "/property-translator/static-1.5657",
  "react-codemirror": "/react-codemirror/static-1.10899",
  "react-colorpicker": "/react-colorpicker/static-2.10468",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8361",
  "rich-text-lib": "/rich-text-lib/static-1.20252",
  "tinymce-data": "/tinymce-data/static-1.41114",
  "tinymce-themes": "/tinymce-themes/static-1.56999",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10146",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5476",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16282",
  "bender-build-tools": "/bender-build-tools/static-1.3397",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10550",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10548",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5303",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1227",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.333",
  "chirp-fetch": "/chirp-fetch/static-1.2154",
  "chatspot-core": "/chatspot-core/static-1.22712",
  "copilot-toolkit": "/copilot-toolkit/static-1.11774",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13290",
  "data-fetching-client": "/data-fetching-client/static-1.9918",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5016",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8964",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29240",
  "usage-tracker": "/usage-tracker/static-1.7617",
  "cms-field-types": "/cms-field-types/static-1.5075",
  "content-icons-ui": "/content-icons-ui/static-1.2324",
  "integrations-lib": "/integrations-lib/static-1.16955",
  "customer-data-objects": "/customer-data-objects/static-1.7948",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1606",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4916",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.90",
  "graphql": "/graphql/static-1.86",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4412",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9335",
  "video-components-external": "/video-components-external/static-1.12086",
  "video-data-lib": "/video-data-lib/static-1.35744",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.225",
  "audio-components": "/audio-components/static-1.6288",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29753",
  "FileManagerImages": "/FileManagerImages/static-1.37546",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1443",
  "html-to-image": "/html-to-image/static-1.58",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "salesImages": "/salesImages/static-1.532",
  "ui-universal-auth": "/ui-universal-auth/static-1.9320",
  "urlinator": "/urlinator/static-1.4793",
  "video-components": "/video-components/static-1.14088",
  "video-embed": "/video-embed/static-1.36578",
  "ts-schema": "/ts-schema/static-1.4266",
  "ContentData": "/ContentData/static-1.69138",
  "layout-data-lib": "/layout-data-lib/static-1.10208",
  "react-dnd-compat": "/react-dnd-compat/static-1.4876",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1801",
  "external-options-client-types": "/external-options-client-types/static-1.4313",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7153",
  "hs-promise-utils": "/hs-promise-utils/static-1.5855",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4030",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9235",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3323",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11404",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5727",
  "magpie-types": "/magpie-types/static-1.5187",
  "simple-logging-lib": "/simple-logging-lib/static-1.3311",
  "avatar-components": "/avatar-components/static-1.2755",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10088",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6845",
  "flux-actions": "/flux-actions/static-1.362",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5139",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14370",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5868",
  "laboratory-lib": "/laboratory-lib/static-3.7413",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8038",
  "redux-observable": "/redux-observable/static-1.72",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10525",
  "unified-auth": "/unified-auth/static-1.834",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.584",
  "breeze-engine-core": "/breeze-engine-core/static-1.884",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "navigation-messaging": "/navigation-messaging/static-1.8065",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13148",
  "content-media-compositions": "/content-media-compositions/static-2.17155",
  "idb-keyval": "/idb-keyval/static-1.48",
  "media-bridge-lib": "/media-bridge-lib/static-1.19352",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1116",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "advanced-menus-core": "/advanced-menus-core/static-1.15525",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12404",
  "ExportDialog": "/ExportDialog/static-6.10639",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34767",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3986",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4320",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.272",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4194",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7058",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3881",
  "persist-promise": "/persist-promise/static-1.3958",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5901",
  "reactive-lib": "/reactive-lib/static-1.982",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.598",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3268",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.380",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1133",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.956",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.53",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.400",
  "slack-ui-library": "/slack-ui-library/static-1.10659",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.4001",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15524",
  "simple-menus-lib": "/simple-menus-lib/static-1.17041",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10018",
  "react-flip-move": "/react-flip-move/static-1.75"
}
};
